/**
 * OrbDocGettingStartedIntroductionAROrbDocGettingStartedIntroductionARPage
 *
 * Page component for OrbDocGettingStartedIntroductionAROrbDocGettingStartedIntroductionARPage
 * Path: /ar/docs/getting-started/introduction
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocGettingStartedIntroductionARDocScreenView as __OrbDocGettingStartedIntroductionARDocScreenView } from '@/components/traits/OrbDocGettingStartedIntroductionARDocScreenView';
import { OrbDocGettingStartedIntroductionARDocAnalyticsView as __OrbDocGettingStartedIntroductionARDocAnalyticsView } from '@/components/traits/OrbDocGettingStartedIntroductionARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocGettingStartedIntroductionAROrbDocGettingStartedIntroductionARPageProps {
  // Add any page-level props here
}

export function OrbDocGettingStartedIntroductionAROrbDocGettingStartedIntroductionARPage(_props: OrbDocGettingStartedIntroductionAROrbDocGettingStartedIntroductionARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"مقدمة إلى Orb","description":"Orb لغة للبرمجيات التي يجب أن تتبع قواعد. تعلن الحالات والأحداث، فيبني المترجم التطبيق أو يخبرك لماذا لا يستطيع.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/getting-started/introduction"},{"locale":"ar","path":"/ar/docs/getting-started/introduction"},{"locale":"sl","path":"/sl/docs/getting-started/introduction"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocGettingStartedIntroductionARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocGettingStartedIntroductionARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocGettingStartedIntroductionAROrbDocGettingStartedIntroductionARPage;
